module.exports = __webpack_public_path__ + "img/i_event-quest_on.7376fb9.png";